import { useParams } from 'react-router-dom'

import { useGetActiveSystemScopeFilterProfileQuery } from 'app/services/api/filterprofiles'

// This hook is used to determine which line is selected in Line View
const useGetCurrentLine = () => {
  const params = useParams<{ lineId: string }>()

  // The history URL for Risk Management falls under two types,
  // its either <url>/<lineID> or <url>/<lineID>/<view>
  // Example: /risk-management/line/10/data-table or /risk-management/line/10/
  const lineId = params.lineId

  const { systemScopeFilterProfile } =
    useGetActiveSystemScopeFilterProfileQuery()

  const tempLine = systemScopeFilterProfile?.continuousRoutes.find(
    (route) => route.id.toString() === lineId
  )?.name

  return tempLine
}

export default useGetCurrentLine
